import Carousel from '@stimulus-components/carousel'
import Swiper from 'swiper'

export default class CarouselStimulusController extends Carousel {
  static values = {
    slidesPerView: Number,
    thumbsSlider: String,
    thumbsPerView: Number,
  };

  static targets = [
    'swiperPagination',
    'swiperButtonPrev',
    'swiperButtonNext'
  ];

  connect() {
    this.initCarousel();
  }

  initCarousel() {
    let sliderThumbs =  false;
    let navigationOptions = false;
    let paginationOptions = false;

    if (this.hasSwiperButtonNextTarget && this.hasSwiperButtonPrevTarget) {
      navigationOptions = {
        nextEl: this.swiperButtonNextTarget,
        prevEl: this.swiperButtonPrevTarget,
      }
    }

    if (this.hasSwiperPaginationTarget) {
      paginationOptions = {
        el: this.swiperPaginationTarget,
        type: 'bullets',
        clickable: true,
      }
    }

    if(this.hasThumbsSliderValue) {
      sliderThumbs = new Swiper(document.getElementById('thumbs-slider'), {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
      });
    }

    this.swiper = new Swiper(this.element, {
      loop: true,
      slidesPerView: this.slidesPerViewValue,
      spaceBetween: 4,
      navigation: navigationOptions,
      pagination: paginationOptions,
      thumbs: {
        swiper: sliderThumbs,
      },
      threshold: 0
    });
  }
}
